import { jsxs as t, jsx as C } from "react/jsx-runtime";
import r from "../svg-icon/svg-icon.component.js";
function n(o) {
  return /* @__PURE__ */ t(r, { width: "24", height: "24", viewBox: "0 0 24 24", ...o, children: [
    /* @__PURE__ */ C("path", { d: "M3 11.99C3 16.9558 7.03421 20.99 12 20.99C16.9658 20.99 21 16.9558 21 11.99C21 7.0242 16.9658 2.98999 12 2.98999C7.03421 2.98999 3 7.0242 3 11.99ZM1.5 11.99C1.5 6.19578 6.20579 1.48999 12 1.48999C17.7942 1.48999 22.5 6.19578 22.5 11.99C22.5 17.7842 17.7942 22.49 12 22.49C6.20579 22.49 1.5 17.7842 1.5 11.99Z" }),
    /* @__PURE__ */ C("path", { d: "M12 7.23999C12.55 7.23999 13 7.68999 13 8.23999C13 8.78999 12.55 9.23999 12 9.23999C11.45 9.23999 11 8.78999 11 8.23999C11 7.97999 11.1 7.72999 11.29 7.52999C11.48 7.33999 11.73 7.23999 12 7.23999Z" }),
    /* @__PURE__ */ C("path", { d: "M11.25 17.74H12.75V11.24H11.25V17.74Z" })
  ] });
}
export {
  n as InfoIcon
};
//# sourceMappingURL=info.js.map
